export type StackOS = 'linux' | 'macos' | 'unknown';
export type MachineOS = 'linux' | 'osx' | 'unknown';
export type NormalizedOS = StackOS;

export type StackStatus = 'edge' | 'stable' | 'frozen' | 'unknown';
export type MachineStatus = 'available' | 'promoted' | 'unknown';

export enum MachineRegionName {
  US = 'US',
  EU = 'EU',
}

export enum MachineRegionId {
  US = 'region-us',
  EU = 'region-eu',
}

export const regionNames: Record<string, MachineRegionName> = {
  [MachineRegionId.US]: MachineRegionName.US,
  [MachineRegionId.EU]: MachineRegionName.EU,
};

export type StackApiItem = {
  id: string;
  os?: string;
  title: string;
  status: string;
  description?: string;
  'description-link'?: string;
  'description-link-gen2'?: string;
  'description-link-gen2-applesilicon'?: string;
  machines?: string[];
  rollbackVersion?: {
    [machineTypeId: string]: { free?: string; paying?: string };
  };
};

export type StackGroupApiItem = {
  label: string;
  status: StackStatus;
  stacks: StackApiItem[];
};

export type MachineApiItem = {
  availableInRegions: Partial<Record<string, MachineTypeInfoApi[]>>;
  availableOnStacks?: string[];
  creditPerMin?: number;
  id: string;
  isDisabled: boolean;
  name: string;
  osId?: string;
};

export type MachineTypeInfoApi = {
  cpuCount: string;
  name: string;
  ram: string;
};

export type MachineType = {
  id: string;
  creditPerMinute?: number;
  os: MachineOS;
  name: string;
  isDisabled: boolean;
  availableInRegions: Partial<Record<MachineRegionName, string[]>>;
  availableOnStacks?: string[];
};

export type MachineTypeDetailedOption = {
  isDisabled: boolean;
  title: string;
  subtitle: string;
  os: MachineOS;
  value: string;
};

export type MachineGroupApiItem = {
  label: string;
  machines: MachineApiItem[];
};

export type MachineTypeGroup = {
  label: string;
  machineTypes: MachineType[];
};

type DefaultStackApiItem = {
  stackId: string;
  projectTypes: string[];
};

export type StacksAndMachinesResponse = {
  hasSelfHostedRunner: boolean;
  runningBuildsOnPrivateCloud: boolean;
  defaultStackId: string;
  defaultMachineId: string;
  defaultStacks: DefaultStackApiItem[];
  defaultMachines: MachineApiItem[];
  groupedStacks: StackGroupApiItem[];
  groupedMachines: MachineGroupApiItem[];
  region: MachineRegionId | null;
};
